module.exports = __webpack_public_path__ + "assets/page5-bg.png";